import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Rule } from 'app/admin/rules/rule.model';
import { RuleGroup } from 'app/admin/rules/rule-group.model';
import { RuleManagementService } from 'app/admin/rules/rule-management.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants, WarmUpService } from 'app/services/warmup/warmup.service';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'add-rule',
    templateUrl: './add-rule.component.html',
    styleUrls: ['./add-rule.component.css']
})
/**
 * Component to add a new rule.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class AddRuleComponent implements OnInit {
    selectedRule: Rule;
    action: string;
    ruleId: number;
    ruleForm: FormGroup;
    arrRuleGroup: RuleGroup[];
    savingRule = false;
    vaidateRule = false;
    validateMessage: string;
    ruleNameValue: string;
    ruleGroupValue: any;
    ruleTextValue: string;
    nameExtension: string = '.drl';

    formErrors = {
        'rulename': '',
        'rulegroup': '',
        'ruletext':''
    };

    validationMessages = {
        'rulename': {
            'required': 'Required field value.',
        },
        'rulegroup': {
            'required': 'Required field value.',
        },
        'ruletext': {
            'required': 'Required field value.',
        }
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private ruleManagementService: RuleManagementService,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.createForm();
        this.setUpRuleGroup();
        this.updateRuleForm();
    }

    setUpRuleGroup() {
        this.ruleManagementService.getRuleGroup()
            .subscribe(response => {
                this.arrRuleGroup = response;
            });
    }
    createForm() {
        this.ruleForm = this.fb.group({
            rulename: ['', Validators.required],
            rulegroup: ['', Validators.required],
            ruletext: ['', Validators.required],

        });
        this.ruleForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.ruleForm) {
            return;
        }
        const form = this.ruleForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    validateRule()
    {
        const rules = new Rule();
        rules.name = this.ruleForm.value.rulename + this.nameExtension;
        rules.ruleText = this.ruleForm.value.ruletext;
        rules.ruleGroupId = this.ruleForm.value.rulegroup;
        this.vaidateRule = true;
        this.validateMessage = null;
        this.ruleManagementService.validateRule(rules)
            .subscribe(
            success => {
                this.vaidateRule = false;
                if (success.arrResult) {
                    this.validateMessage = success.arrResult;
                }
                else
                {
                    this.callSnackBarServiceForRuleValidate(success);
                }
            },
            err => {
                this.vaidateRule = false;
                this.callSnackBarServiceForRuleValidate(err);
            }
        );
    }

    callSnackBarServiceForRuleValidate(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.RULE_VALIDATE_SUCCESSFULL,
            MessageService.RULE_VALIDATE_FAILURE);
    }

    onSubmit({ value, valid }): void {
        const rules = new Rule();
        rules.id = this.ruleId;
        rules.name = value.rulename.trim() + this.nameExtension;
        rules.ruleText = value.ruletext;
        rules.ruleGroupId = value.rulegroup;
        this.savingRule = true;
        this.validateMessage = null;
        this.ruleManagementService.addRule(rules)
            .subscribe(
            success => {
                this.savingRule = false;
                if (success.flagResult) {
                    if(success.arrResult.errors)
                    {
                        this.validateMessage = success.arrResult.errors;
                    }
                    else
                    {
                        this.trackingService
                            .emitEvent(
                            TrackingConstants.RULE_MANAGEMENT,
                            TrackingConstants.SAVE_RULE,
                            TrackingConstants.SUCCESS, 1);
                        this.callSnackBarServiceForRuleSave(success, this.action);
                        this.dialogRef.close(success.arrResult);
                    }
                }
            },
            err => {
                this.savingRule = false;
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_MANAGEMENT,
                    TrackingConstants.SAVE_RULE,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarServiceForRuleSave(err, this.action);
            }
        );
    }

    callSnackBarServiceForRuleSave(response: any, operation: string) {
        this.snackBarService
            .showStatus(response,
            operation === 'Add'
            && MessageService.ADD_RULE_SUCCESS || MessageService.UPDATE_RULE_SUCCESS,
            MessageService.ADD_RULE_FAILURE);
    }

    closeDialog(formResponse: Object): void {
        this.ruleForm.reset();
        this.dialogRef.close(formResponse);
    }

    updateRuleForm(): void {
        if (this.selectedRule) {
            this.ruleId = this.selectedRule.id;
            let updatedRuleName = this.selectedRule.name.substring(0, this.selectedRule.name.indexOf('.'));
            if (!updatedRuleName)
            {
                updatedRuleName = this.selectedRule.name;
            }
            this.ruleForm.patchValue({
                rulename: updatedRuleName,
                rulegroup: this.selectedRule.ruleGroupId,
                ruletext: this.selectedRule.ruleText,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/rules/addrule/add-rule.component.ts